// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"617":"c30db67a","787":"94953e6e"}[chunkId] + ".chunk.js";
};